import { FaCheck } from "components/atoms/Icon/fa/FaCheck";
import Title from "components/atoms/Title";

import styles from "./Index.module.scss";

const Card = ({ title, price, listContent }) => {
  return (
    <div className="mb-10 lg:col-6">
      <div className={`${styles.cardWrapper}`}>
        <Title
          as="h3"
          text={title}
          className="text-center text-bbc-30px font-semibold text-bbc-brand-700"
          style={{ marginBottom: "30px" }}
        />
        <ul className="mb-8">
          {listContent.map((item, index) => (
            <li key={index} className="relative mb-2">
              <FaCheck
                className="absolute top-1.5 left-0 text-bbc-brand-500"
                size={12}
              />
              <span className="inline-block pl-7">{item.text}</span>
            </li>
          ))}
        </ul>
        <div className="border-t border-t-bbc-neutral-300 pt-8 pb-4 text-center">
          <p className={`${styles.price}`}>
            <span>US$</span>
            {price}
          </p>
        </div>
      </div>
    </div>
  );
};

const Component = ({ title, data }) => {
  return (
    <>
      {title && (
        <Title
          text={title}
          className="mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800 lg:mb-10 lg:text-bbc-40px"
        />
      )}
      <div className="m-auto lg:col-10">
        <div className="row justify-around">
          {data.map((item, index) => (
            <Card
              key={index}
              title={item.title}
              price={item.price}
              listContent={item.listContent}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default Component;
